import { HttpContext, HttpContextToken } from "@angular/common/http";

export const SKIP_AUTH_INTERCEPTOR = new HttpContextToken(() => false);

/**
 * Flags an http context so the interceptor will skip adding authentication or refreshing the token.
 * Used for login and token refresh requests, so the interceptor doesn't get stuck in a loop.
 * @param context The http context to flag. If not provided, a new context will be created.
 */
export function SkipAuthInterceptor(context : HttpContext = new HttpContext()) : HttpContext{
    context.set(SKIP_AUTH_INTERCEPTOR, true);    
    return context;
}

/**
 * Checks if the http context has been flagged to skip the auth interceptor.
 * @param context The http context to check.
 * @returns True if the context has been flagged to skip the auth interceptor, otherwise false.
 */
export function ShouldSkipAuthInterceptor(context : HttpContext) : boolean{
    return context.get(SKIP_AUTH_INTERCEPTOR) === true;
}